import auth from "@/api/auth";
import session from "@/api/session";

const state = () => ({
  user: JSON.parse(localStorage.getItem("user")) || {},
  token: localStorage.getItem("token") || null,
  refresh: localStorage.getItem("refresh") || null,
});

const mutations = {
  SET_USER(state, user) {
    state.user = user || JSON.parse(localStorage.getItem("user"));
  },
  SET_TOKEN(state, { token, refresh }) {
    state.token = token || localStorage.getItem("token");
    state.refresh = refresh || localStorage.getItem("refresh");
  },
  SET_REFRESH(state, token) {
    state.token = token || localStorage.getItem("token");
  },
  LOGOUT_USER(state) {
    state.user = {};
    state.token = null;
    delete session.defaults.headers.common["Authorization"];
  },
};

const actions = {
  setUser({ commit }, payload) {
    const profile = payload.getBasicProfile();

    const user = {
      id: profile.getId(),
      fullName: profile.getName(),
      firstName: profile.getGivenName(),
      lastName: profile.getFamilyName(),
      imageURL: profile.getImageUrl(),
      email: profile.getEmail(),
    };

    localStorage.setItem("user", JSON.stringify(user));

    commit("SET_USER", user);
    return new Promise(resolve=>{ resolve(); });
  },

  async setTokens({ commit }) {
    const { data } = await auth.getToken();

    const token = data.access;
    const refresh = data.refresh;

    localStorage.setItem("token", token);
    localStorage.setItem("refresh", refresh);

    commit("SET_TOKEN", { token, refresh });
    return new Promise(resolve=>{ resolve(); });
  },

  async refreshTokens({ commit }, token) {
    localStorage.setItem("token", token);
    commit("SET_TOKEN", token);
  },

  logoutUser({ commit }) {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh");
    localStorage.removeItem("user");
    commit("LOGOUT_USER");
  },
};

const getters = {
  isLoggedIn: (state) => !!state.token,
  getUser: (state) => state.user,
  token: (state) => state.token,
  refresh: (state) => state.refresh,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
